import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';
import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';
import sortBy from 'lodash/sortBy';
import indexOf from 'lodash/indexOf';
import uniqBy from 'lodash/uniqBy';
import omitBy from 'lodash/omitBy';
import get from 'lodash/get';
import set from 'lodash/set';

export default class ObjectUtils {
    static keepIds(objList: Object) {
        const res = { ...objList };
        for (const key in res) {
            if (res.hasOwnProperty(key)) {
                res[key] = res[key].id;
            }
        }
        return res;
    }

    static formatKey(key: string): string {
        return key.replace('[', '.').replace(']', '');
    }

    static getSubValueFromKey(obj, key: string) {
        const formatKey = ObjectUtils.formatKey(key);
        return get(obj, formatKey);
    }

    static setSubValueFromKey(obj, key: string, val) {
        const formatKey = ObjectUtils.formatKey(key);
        set(obj, formatKey, val);
        return obj;
    }

    static jsonCopy<T>(obj: T): T {
        return JSON.parse(JSON.stringify(obj));
    }

    static deepCopy<T>(obj: T): T {
        if (!obj) {
            return undefined;
        }
        return cloneDeep(obj);
    }

    static copy<T>(obj: T): T {
        return Object.assign({}, obj);
    }

    static isEmpty(obj): boolean {
        return isEmpty(obj);
    }

    static isEqual(obj, obj2, noNull = false) {
        if (noNull) {
            return isEqual(pickBy(obj, identity), pickBy(obj2, identity));
        }
        return isEqual(obj, obj2);
    }

    static removePathFromObject(obj, path) {
        return omit(obj, path);
    }

    static sortByDay(arr) {
        const order = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
        return sortBy(arr, function (obj) {
            return indexOf(order, obj.short);
        });
    }

    static uniqBy(arr, key) {
        return uniqBy(arr, key);
    }

    static diff(obj, obj2) {
        return omitBy(obj, function (v, k) {
            return obj2[k] === v;
        });
    }

    static cleanEmpty(obj) {
        if (obj === null || obj === undefined || this.isEmpty(obj)) {
            return true;
        }
        let shouldDelete = true;
        Object.keys(obj).forEach((k) => {
            if (typeof obj[k] === 'object') {
                const subRes = this.cleanEmpty(obj[k]);
                if (subRes) {
                    delete obj[k];
                }
                shouldDelete = shouldDelete && subRes;
            } else {
                shouldDelete = false;
            }
        });
        return shouldDelete;
    }
}
